export const workspaceEn = {
  workspace: {
    nav: {
      section: 'Workspace',
      chat: 'Chat',
      settings: 'Settings',
      workspaceSettings: 'Workspace settings',
      memory: 'Memory',
      knowledge: 'Knowledge',
      wiki: 'Wiki',
    },
    chat: {
      title: 'Chat',
      subtitle: 'Ask your workspace agents about repos, mail, or anything else',
      empty: 'Choose an agent and ask a question — GitHub, Gmail, memory, or general chat.',
      welcomeTitle: 'How can I help you today?',
      thinking: 'Thinking…',
      analyzing: 'Analyzing…',
      preparing: 'Preparing response…',
      callingTool: 'Calling {tool}…',
      processingResult: 'Processing result…',
      loadingSession: 'Loading session…',
      placeholder: 'e.g. List my open PRs in org/repo',
      placeholderShort: 'Ask anything…',
      send: 'Send',
      newChat: 'New chat',
      showSessions: 'Sessions',
      copyBlock: 'Copy',
      copied: 'Copied to clipboard',
      copyFailed: 'Failed to copy',
      errors: {
        genericTitle: 'Something went wrong',
        genericDescription: 'The assistant could not complete your request. Try again or check your workspace settings.',
        dismiss: 'Dismiss',
        emptyResponseTitle: 'No response',
        emptyResponse: 'The assistant did not return a message. Try sending your question again.',
        streamFailedTitle: 'Connection error',
        streamFailed: 'The response stream was interrupted or could not be read. Try again.',
        byok: {
          title: 'OpenRouter API key required',
          description: 'On the free plan you need your own OpenRouter API key to use AI chat. Add it in billing settings or upgrade your plan.',
          cta: 'Open billing',
        },
        usageLimit: {
          title: 'Usage limit reached',
          description: 'You have reached your monthly AI usage limit. Upgrade your plan or wait until the limit resets.',
          cta: 'View plans',
        },
      },
    },
    agent: {
      selectLabel: 'Agent',
      selectPlaceholder: 'Select agent',
      loadError: 'Failed to load agents',
      lockedHint: 'Agent is fixed for this conversation. Start a new chat to switch.',
    },
    attachments: {
      attach: 'Attach file',
      remove: 'Remove attachment',
      preview: 'Preview image',
      visionRequired: 'Select a vision-capable model to attach images',
      kinds: {
        image: 'Image',
        text: 'Text',
        pdf: 'PDF',
      },
      errors: {
        unsupportedType: 'Unsupported file type',
        tooLarge: 'File is too large (max 10 MB)',
        tooMany: 'Too many attachments (max 5)',
        uploadFailed: 'Failed to upload attachment',
        deleteFailed: 'Failed to remove attachment',
      },
    },
    composer: {
      plus: {
        open: 'Add attachment or source',
        addFiles: 'Add photos and files',
        connectGithub: 'Connect GitHub',
        connectGmail: 'Connect Gmail',
        more: 'More integrations…',
        removeHint: 'Remove context hint',
        providerDisabled: 'This integration is disabled — opening settings',
        providers: {
          github: 'GitHub',
          gmail: 'Gmail',
          knowledge: 'Knowledge',
          web: 'Web search',
        },
      },
    },
    blocks: {
      sources: {
        title: 'Sources',
      },
    },
    memory: {
      title: 'Memory',
      subtitle: 'Semantic memories used by the agent across sessions',
      search: 'Search',
      searchPlaceholder: 'Search memories (semantic)…',
      searchAction: 'Search',
      semanticHint: 'Showing semantic search results',
      filterScope: 'Scope',
      add: 'Add memory',
      addPlaceholder: 'A fact or preference to remember…',
      addAction: 'Save',
      loading: 'Loading memories…',
      empty: 'No memories yet. Add one above or let the agent save facts during chat.',
      total: '{count} memories',
      saved: 'Memory saved',
      saveFailed: 'Failed to save memory',
      updated: 'Memory updated',
      updateFailed: 'Failed to update memory',
      deleted: 'Memory deleted',
      deleteFailed: 'Failed to delete memory',
      edit: 'Edit',
      saveEdit: 'Save',
      cancelEdit: 'Cancel',
      delete: 'Delete',
      similarity: 'similarity {value}',
      scopes: {
        all: 'All scopes',
        user: 'User',
        agent: 'Agent',
        session: 'Session',
      },
    },
    knowledge: {
      title: 'Knowledge',
      subtitle: 'Documents available to agents via RAG search',
      add: 'Add document',
      titlePlaceholder: 'Document title',
      contentPlaceholder: 'Paste text to add to the knowledge base…',
      addAction: 'Add',
      loading: 'Loading documents…',
      empty: 'No documents yet. Paste some text above to get started.',
      total: '{count} documents',
      chunkCount: '{count} chunks',
      added: 'Document queued for ingest',
      addFailed: 'Failed to add document',
      deleted: 'Document deleted',
      deleteFailed: 'Failed to delete document',
      preview: 'Preview',
      delete: 'Delete',
      chunkLabel: 'Chunk {index}',
      statuses: {
        pending: 'Processing…',
        ready: 'Ready',
        failed: 'Failed',
      },
    },
    wiki: {
      title: 'Wiki',
      subtitle: 'Second Brain — ingested knowledge with folders, links, and graph',
      tabs: {
        pages: 'Pages',
        graph: 'Graph',
      },
      allFolders: 'All folders',
      folders: {
        raw: 'Raw',
        inbox: 'Inbox',
        entities: 'Entities',
        concepts: 'Concepts',
        summaries: 'Summaries',
        meta: 'Meta',
      },
      loading: 'Loading wiki pages…',
      empty: 'No pages yet. Create one or use the Ingest button.',
      total: '{count} pages',
      newPage: 'New page',
      ingest: 'Ingest',
      pageTitle: 'Title',
      pageBody: 'Body (Markdown)',
      titlePlaceholder: 'Page title',
      bodyPlaceholder: 'Write Markdown content…',
      createAction: 'Create',
      pageCreated: 'Page created',
      createFailed: 'Failed to create page',
      delete: 'Delete',
      deleted: 'Page deleted',
      deleteFailed: 'Failed to delete page (may be immutable)',
      deprecate: 'Deprecate',
      deprecated: 'Page deprecated',
      deprecateFailed: 'Failed to deprecate page',
      statusDeprecated: 'Deprecated',
      confirmDeprecate: 'Deprecate page?',
      confirmDeprecateDesc: 'This will mark the page as deprecated and remove it from search results.',
      cancel: 'Cancel',
      deprecateAction: 'Deprecate',
      ingestTitle: 'Ingest content',
      ingestTitleLabel: 'Title (optional)',
      ingestTitlePlaceholder: 'Title for the ingested content',
      ingestContentLabel: 'Content',
      ingestContentPlaceholder: 'Paste article, document, or notes to ingest…',
      ingestAction: 'Ingest',
      ingested: 'Content ingested into wiki',
      ingestTruncated: 'Content ingested (ripple truncated — limit reached)',
      ingestFailed: 'Failed to ingest content',
      searchPlaceholder: 'Search pages…',
      sortBy: 'Sort',
      sort: {
        updated_desc: 'Updated (newest)',
        updated_asc: 'Updated (oldest)',
        created_desc: 'Created (newest)',
        created_asc: 'Created (oldest)',
        title_asc: 'Title A–Z',
        title_desc: 'Title Z–A',
      },
      selectAll: 'Select all',
      selectedCount: 'Selected: {count}',
      deleteSelected: 'Delete selected',
      clearSelection: 'Clear selection',
      bulkDeleted: 'Deleted {count} pages',
      bulkDeleteFailed: 'Failed to delete selected pages',
      confirmBulkDelete: 'Delete selected pages?',
      confirmBulkDeleteDesc: '{count} pages will be permanently deleted. Immutable pages (🔒) will be skipped.',
      purgeAll: 'Purge all',
      purged: 'Purged all pages ({count})',
      purgeFailed: 'Failed to purge wiki',
      confirmPurge: 'Purge entire wiki?',
      confirmPurgeDesc: 'This will permanently delete ALL wiki pages. This action cannot be undone.',
      purgeConfirmLabel: 'Type PURGE to confirm',
      outgoingLinks: 'Outgoing links',
      incomingLinks: 'Incoming links',
      expandDetail: 'Open in dialog',
      collapseFolders: 'Collapse folders',
      expandFolders: 'Expand folders',
      graphLoading: 'Loading graph…',
      graphEmpty: 'No pages to display in graph',
      help: {
        newPage: 'Manually create a wiki page in the Inbox folder',
        ingest: 'Paste any text — AI splits it into pages, extracts entities and creates a summary',
        deprecate: 'Mark page as outdated — it will be removed from agent search results',
        delete: 'Permanently delete the page (not possible for 🔒 immutable pages)',
        purgeAll: 'Permanently delete all wiki pages (irreversible)',
        immutable: 'System page — cannot be deleted or edited',
        howItWorks: 'How does Wiki work?',
        howItWorksBody: 'Wiki is your Second Brain. Paste content via Ingest — AI automatically creates pages, extracts entities and summaries. Pages can link to each other using [[slug]] syntax. The Graph shows connections. The agent has access to the wiki in every chat.',
        ingestDialogHint: 'AI will process the text and create up to several related pages across different folders.',
        newPageLinkHint: 'You can link to other pages using [[page-slug]] syntax.',
        linkPicker: {
          title: 'Insert link to page',
          search: 'Search pages…',
          insert: 'Insert link',
          empty: 'No matching pages',
          hint: 'Click a page to insert [[slug]] at cursor position',
        },
        folders: {
          raw: 'Raw content right after Ingest, before AI processing',
          inbox: 'Pages created manually or awaiting classification',
          entities: 'Extracted entities (people, companies, projects…)',
          concepts: 'Concepts and definitions from your knowledge',
          summaries: 'Document summaries generated by AI',
          meta: 'System pages (index, librarian instructions)',
        },
      },
    },
    sessions: {
      title: 'Sessions',
      search: 'Search sessions…',
      empty: 'No sessions yet. Start a new chat.',
      noResults: 'No sessions match your search.',
      loadError: 'Failed to load sessions',
      untitled: 'Untitled chat',
    },
    audit: {
      title: 'Run trace',
      description: 'Step history, system prompt, and session metadata',
      open: 'Audit',
      openTooltip: 'Run audit',
      trace: 'Trace',
      systemPrompt: 'System prompt',
      session: 'Session',
      noRun: 'Send a message to view audit data',
      noSystemPrompt: 'System prompt will be available after the first agent response',
      runId: 'Run ID',
      status: 'Status',
      tokens: 'Tokens',
      tokensSummary: '{prompt} input + {completion} output = {total} total',
      cost: 'Cost',
      copyRun: 'Copy run',
      copied: 'Run copied to clipboard',
      copyFailed: 'Failed to copy run',
    },
    model: {
      selectPlaceholder: 'Select model',
      searchPlaceholder: 'Search models…',
      empty: 'No models match your search.',
      current: 'Model: {name}',
      currentLabel: 'Model',
      defaultModel: 'Default model',
      recommended: 'Recommended',
      price: '{input} in / {output} out per 1M',
      context: '{size} context',
      sortBy: 'Sort',
      sort: {
        recommended: 'Recommended',
        power: 'Power',
        price: 'Price',
        context: 'Context',
        name: 'Name',
      },
      tier: {
        frontier: 'Frontier',
        balanced: 'Balanced',
        fast: 'Fast',
      },
      feature: {
        vision: 'Image input',
        tools: 'Tool calling',
        reasoning: 'Extended reasoning',
      },
      browseAll: 'Browse all',
      showingOf: '{shown} of {total}',
      results: '{count} models',
      filters: {
        capabilities: 'Capabilities',
        requireVision: 'Image input',
        requireTools: 'Tool calling',
        requireReasoning: 'Extended reasoning',
        recommendedOnly: 'Recommended only',
        maxOutputCost: 'Max output cost',
        minContext: 'Min context',
        providers: 'Providers',
        noLimit: 'Any',
        reset: 'Reset filters',
      },
    },
    settings: {
      subtitle: 'Agent and product integration configuration',
      models: 'Models',
      modelsDescription: 'Choose the default model used in chat',
      modelsHint: 'Changes apply to new messages. Workspace admins may restrict available models.',
      integrations: 'Integrations',
      integrationsDescription: 'Connect GitHub, Jira, and GitLab to the workspace agent',
      backToChat: 'Back to chat',
    },
  },
}
